/**
 * InvitationService.js
 *
 * Service module for managing invitation/session admin operations.
 * Handles API calls for tracks and side track registration management.
 */

import { api } from '@/services/httpCall';
import { GET } from '@/shared/constants/httpMethods';

/**
 * Fetches all sessions/tracks from the invitation admin endpoint
 * @returns {Promise<{statusCode: number|null, data: any}>} Response with sessions list
 */
export const getAllSessions = async () => {
  const response = await api(GET, '/invitation-admin');
  return response;
};

/**
 * Fetches session details including registered users
 * @param {string|number} sessionId - The session ID to fetch details for
 * @returns {Promise<{statusCode: number|null, data: any}>} Response with session details and users
 */
export const getSessionDetails = async (sessionId) => {
  const response = await api(GET, `/invitation-admin/${sessionId}`);
  return response;
};

/**
 * Fetches session counts (registrants and attendance)
 * @param {string|number} sessionId - The session ID to fetch counts for
 * @returns {Promise<{statusCode: number|null, data: any}>} Response with registrants and attendance counts
 */
export const getSessionCounts = async (sessionId) => {
  const response = await api(GET, `/invitation-admin/counts/${sessionId}`);
  return response;
};
